import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent {
    public title: string;
    public message: string;

    constructor(public dialogRef: MatDialogRef<ErrorDialogComponent>) {}
}